import {TrabajadorEntity} from '../entity/trabajador.entity';
import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {CommonResponse} from "../response/common.response";
import {ApiTrabajadorRepository} from "../../data/datasource/api/trabajador/api.trabajador.repository";
import {UtilityService} from "../services/utility.service";
import {LocalTrabajadorRepository} from "../../data/datasource/local/trabajador/local.trabajador.repository";

@Injectable({
    providedIn: 'root'
})
export class Trabajador extends TrabajadorEntity {
    PARAM = environment.PARAM;

    constructor(
        public apiTrabajadorRepository?: ApiTrabajadorRepository,
        public localTrabajadorRepository?: LocalTrabajadorRepository
    ) {
        super();
    }

    /**
     * Armar el objeto en base a sus atributos: valor
     * Valido si el service 'TrabajadorService' esta inyectado y es un objeto,
     * para pasarlo como parametro en el constructor
     */
    public static build(data: {}, apiTrabajadorRepository?: ApiTrabajadorRepository) {
        const trabajador = new Trabajador();
        trabajador.apiTrabajadorRepository = apiTrabajadorRepository;
        // tslint:disable-next-line:forin
        for (const propiedad in data) {
            trabajador[propiedad] = data[propiedad];
        }
        return trabajador;
    }

    public async login(credenciales: any): Promise<CommonResponse> {
        const response = await this.apiTrabajadorRepository.login(credenciales);
        if (response.data) {
            if (Array.isArray(response.data)) {
                response.data = response.data
                // @ts-ignore
                    .map(Trabajador.build)
                    .filter(Boolean);
            } else {
                response.data = Trabajador.build(response.data);
            }
        }
        return response;
    }

    public guardarSesion(sesionData) {
        if (sesionData.token) {
            this.localTrabajadorRepository.guardarTrabajadorSesion(sesionData);
            this.localTrabajadorRepository.guardarToken(sesionData.token);
        }
    }

    public async guardarDNI(dni: string) {
        if (dni) {
            await this.localTrabajadorRepository.guardarDNI(dni);
        }
    }

    public async getDNI() {
        return await this.localTrabajadorRepository.getDNI();
    }

    public async deleteTokenByToken(): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.deleteTokenByToken(this.localTrabajadorRepository.obtenerToken());
    }

    public async aceptarTerminosYCondiciones(): Promise<CommonResponse> {
        const response = await this.apiTrabajadorRepository.aceptarTerminosYCondiciones();
        if (response.data) {
            if (Array.isArray(response.data)) {
                response.data = response.data
                // @ts-ignore
                    .map(Trabajador.build)
                    .filter(Boolean);
            } else {
                response.data = Trabajador.build(response.data);
            }
        }
        return response;
    }

    public async registrarSintomas(objeto: any): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarSintomas(objeto);
    }

    public async registrarSalida(objeto: any): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarSalida(objeto);
    }

    public async registrarEntrada(objeto: any): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarEntrada(objeto);
    }

    public async getDataByDNI(dni: any): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getDataByDNI(dni);
    }
    public async getEstadoCivilList(): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getEstadoCivilList();
    }
    public async getDocumentos(): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getDocumentos();
    }
    public async getGradoInstruccionList(): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getGradoInstruccionList();
    }
    public async update(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.update(objeto);
    }
    public async registrarSolicitud(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarSolicitud(objeto);
    }
    public async getHistorialVacaciones(trabajadorID, pagina, registros, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getHistorialVacaciones(trabajadorID, pagina, registros, empresaId);
    }

    public async getHistorialCupones(trabajadorID, pagina, registros, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getHistorialCupones(trabajadorID, pagina, registros, empresaId);
    }
    public async getTipocupoDisponible(trabajadorID, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getTipocupoDisponible(trabajadorID, empresaId);
    }
    public async registrarCupon(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarCupon(objeto);
    }

    // Solicitudes (Descanso medico)
    public async getSolicitudes_DescandoMedico(trabajadorID, pagina, registros, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getSolicitudes_DescandoMedico(trabajadorID, pagina, registros, empresaId);
    }
    public async getSolicitudes_Permiso(trabajadorID, pagina, registros, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getSolicitudes_Permiso(trabajadorID, pagina, registros, empresaId);
    }
    public async getTiposPermiso(): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getTiposPermiso();
    }
    public async getInicioPortal(trabajadorID, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getInicioPortal(trabajadorID, empresaId);
    }
    public async guardarSolicitud(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.guardarSolicitud(objeto);
    }
    public async getDataSolicitud(solicitudId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getDataSolicitud(solicitudId);
    }

    public async getHistorialDocumentos(trabajadorID, tipoDoc, pagina, registros, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getHistorialDocumentos(trabajadorID, tipoDoc, pagina, registros, empresaId);
    }
    public async registrarDocumento(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarDocumento(objeto);
    }
    public async adjuntarArchivo(file: FormData): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.adjuntarArchivo(file);
    }
    public async guardarFormatoVacaciones(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.guardarFormatoVacaciones(objeto);
    }
    public async generarCodigoAcceso(dni, puesto = null): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.generarCodigoAcceso(dni, puesto);
    }
    public async validarCodigoAcceso(dni, codigo): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.validarCodigoAcceso(dni, codigo);
    }

    public async getHistorialMovilidad(pagina, registros, obj, empresaId): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getHistorialMovilidad(pagina, registros, obj, empresaId);
    }
    public async registrarMovilidad(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarMovilidad(objeto);
    }

    public async buscarPorDocumentoMovilidad(numero: string, regimen: string): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.buscarPorDocumentoMovilidad(numero, regimen);
    }
    public async getConceptosList(): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getConceptosList();
    }
    public async eliminarMovilidad(movilidadid: string): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.eliminarMovilidad(movilidadid);
    }

    public async getEncuestaClima(dni: string): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.getEncuestaClima(dni);
    }
    public async registrarEncuestaClima(objeto): Promise<CommonResponse> {
        return await this.apiTrabajadorRepository.registrarEncuestaClima(objeto);
    }

    public cerrarSesion() {
        this.localTrabajadorRepository.eliminarTrabajadorSesion();
        this.localTrabajadorRepository.eliminarToken();
    }

    /**
     * Valida si el producto tiene un id valido
     */
    public tieneIdValido() {
        return UtilityService.esUnIDValido(this.trabajador_id);
    }

    /**
     * Valida si el objeto esta activo
     */
    public estaActivo() {
        // tslint:disable-next-line:triple-equals
        return this.trabajador_estado == this.PARAM.ACTIVO;
    }

    /**
     * Valida si el objeto esta activo
     */
    public estadoDescripcion() {
        // tslint:disable-next-line:triple-equals
        return this.estaActivo() ? 'Activo' : 'Inactivo';
    }

    /**
     * Resetar el objeto con valores por defecto
     */
    public reset() {
        this.setTrabajador_estado(this.PARAM.ACTIVO);
    }

}
